import React from 'react';
import { MapContainer, TileLayer, CircleMarker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

function Location({ center }) {
  if (!center?.lat || !center?.lng) {
    return null;
  }

  return (
    <MapContainer
      center={[center.lat, center.lng]}
      zoom={14}
      style={{ height: '100%', width: '100%' }}
      zoomControl={false}
      attributionControl={true}
      dragging={true}
      scrollWheelZoom={false}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <CircleMarker
        center={[center.lat, center.lng]}
        radius={10}
        pathOptions={{
          color: '#3388ff',
          fillColor: '#3388ff',
          fillOpacity: 0.6,
          weight: 2,
        }}
      />
    </MapContainer>
  );
}

export default React.memo(Location);
